import type { ReactNode } from 'react';

export function Loading({ label = '불러오는 중입니다…' }: { label?: string }) {
  return (
    <div className="state">
      <div className="spinner" />
      {label}
    </div>
  );
}

export function Empty({ title = '데이터가 없습니다.', children }: { title?: string; children?: ReactNode }) {
  return (
    <div className="state">
      <div className="state__title">{title}</div>
      {children}
    </div>
  );
}

export function ErrorState({
  error,
  onRetry,
  children,
}: {
  error: unknown;
  onRetry?: () => void;
  /** 다시 시도 옆에 함께 놓을 추가 동작 (예: 목록으로 이동) */
  children?: ReactNode;
}) {
  const message = error instanceof Error ? error.message : '알 수 없는 오류가 발생했습니다.';
  return (
    <div className="state">
      <div className="state__title">문제가 발생했습니다</div>
      <p>{message}</p>
      {(onRetry || children) && (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
          {onRetry && (
            <button type="button" className="btn btn--outline btn--sm" onClick={onRetry}>
              다시 시도
            </button>
          )}
          {children}
        </div>
      )}
    </div>
  );
}

export function Alert({ tone = 'info', children }: { tone?: 'info' | 'error'; children: ReactNode }) {
  return <div className={`alert alert--${tone}`}>{children}</div>;
}
